import { createContext, useContext } from "react";

/** True when inside a ValidationProvider — used to reserve error space in FormItem */
const FormValidationActiveContext = createContext(false);

/** When true, all FormItems should show their errors regardless of touch state */
const FormValidationSubmittedContext = createContext(false);

export const FormValidationActiveProvider =
  FormValidationActiveContext.Provider;
export const FormValidationSubmittedProvider =
  FormValidationSubmittedContext.Provider;

export const useIsFormValidationActive = () =>
  useContext(FormValidationActiveContext);
export const useIsFormSubmitted = () =>
  useContext(FormValidationSubmittedContext);
